<template>
  <SectionTemplate
    class="aio-section"
    title="从文案到讲稿，AI一站式完成PPT与演讲内容创作"
    :desc="sectionDesc"
  >
    <div class="aio-section__card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        :action="handler"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import FeatureCard from '~/design/components/feature-card/index.vue';

defineProps<{
  handler: () => void;
}>();

const sectionDesc = `不止于生成PPT幻灯片。我们独有的AI能同步创作专业演讲逐字稿，并提供丰富的模板与智能排版，让你彻底告别内容与设计的繁琐，专注创意本身。`;

const featureList = [
  {
    title: `“PPT+逐字讲稿”同步生成
一体化流程告别割裂创作`,
    description:
      '输入内容后，AI不仅生成PPT，更会为每一页自动撰写逻辑连贯的演讲逐字稿，彻底解决“做PPT”与“写讲稿”分离的痛点。生成的PPT与讲稿可直接用于后续制作数字人讲解视频。',
    image: getFeUrl(
      '/youyan-platform/ai-ppt/efficiency/script.jpg?x-oss-process=image/format,webp',
    ),
    btnText: '免费试用',
  },
  {
    title: `海量专业模板与AI智能排版
无需设计，秒出精美幻灯片`,
    description:
      '内置丰富的PPT模板库，覆盖科技、教育、营销等多行业场景。选择模板后，AI自动完成图文排版与美化，无需任何设计技能，即可生成风格统一、版式专业的演示文稿。',
    image: getFeUrl(
      '/youyan-platform/ai-ppt/efficiency/template.jpg?x-oss-process=image/format,webp',
    ),

    reverse: true,
    btnText: '免费试用',
  },
  {
    title: `AI深度理解内容结构
从零构建逻辑清晰的PPT大纲`,
    description:
      '无论是输入一句话想法，还是上传文档、演讲稿，AI都能智能解析文本，提取核心观点，自动生成结构严谨、重点突出的PPT大纲与页面内容，确保信息传达专业准确。',
    btnText: '免费试用',
    image: getFeUrl(
      '/youyan-platform/ai-ppt/efficiency/outline.jpg?x-oss-process=image/format,webp',
    ),
  },
  {
    title: `在线自由编辑与多格式导出
创作全程灵活可控`,
    description:
      'AI生成的结果仅是起点。提供在线PPT编辑器，支持用户无限制地修改每一页内容和设计。完成编辑后，可免费下载为pptx、pdf、图片格式，满足各类后续使用需求。',
    image: getFeUrl(
      '/youyan-platform/ai-ppt/efficiency/format.jpg?x-oss-process=image/format,webp',
    ),
    btnText: '免费试用',
    reverse: true,
  },
];
</script>

<style lang="scss" scoped>
.aio-section {
  background-color: var(--x-back-3);
}
.aio-section__card-list {
  display: flex;
  flex-direction: column;
  gap: 240px;
  align-items: center;
}
</style>
